<template>
  <div>
    <rich-radio-group
      :options="cityData"
      position="right"
      :value="commonCityChecked.value"
      @input="cityChange"
    />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  components: {},
  name: 'cityPopup',
  props: {
    cityData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    ...mapState('bizoppV2', ['cityIdsWithAuth', 'commonCityChecked'])
    // cityId() {
    //   return this.cityIdsWithAuth && this.cityIdsWithAuth.cityId
    // }
  },
  data() {
    return {}
  },

  methods: {
    ...mapMutations('bizoppV2', [
      'updateCommonCityChecked',
      'updateCommonAreaChecked'
    ]),
    cityChange(val) {
      if (val) {
        this.updateCommonCityChecked({
          value: val
        })
        this.updateCommonAreaChecked(['allChild'])
        this.$emit('cityChange', val)
      }
    }
  }
}
</script>
